<template>
  <div class="footerPage">
    <div class="name">
      <img src="@/assets/logo.png" />
      <span>{{ footerInfo.companyName }}</span>
    </div>
    <div class="menu">
      <span v-for="(item, index) in footerInfo.menuList" :key="index">{{ item }}</span>
    </div>
    <div class="contact">
      <div class="contactItem" v-for="(item, index) in footerInfo.contactList" :key="index">
        <img :src="item.url" />
        <span>{{ item.info }}</span>
      </div>
    </div>
    <div class="copyright">
     <div> {{ footerInfo.copyright }}</div>
       <a href="https://beian.miit.gov.cn/" target="_blank" style=" text-decoration:none;color:#A8E2E6;margin-left: 10px"><div> {{ footerInfo.recordNum }}</div></a>
    <div>
      <el-image :src="require('@/assets/u1.png')"  style="width: 20px; height: 20px"></el-image>
      <a href="https://www.beian.gov.cn/portal/index.do" target="_blank" style=" text-decoration:none;color:#A8E2E6">50010802001320</a>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerPage",
  data() {
    return {
      footerInfo: {}//底部信息
    }
  },
  mounted() {

  },
  watch: {
    "$store.state.currentLang": {
      immediate: true,
      handler(newVal, oldVal) {
        console.log('watchFooter')
        if (newVal == 'Cn') {
          this.$i18n.locale = "zh-CN"
          this.footerInfo = this.$t('translateObj.footerInfo')
        }
        if (newVal == 'En') {
          this.$i18n.locale = "en-US"
          this.footerInfo = this.$t('translateObj.footerInfo')
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../style/index";
.footerPage {
  padding: 70px 310px;
  background: #00A0A9;
  text-align: left;
  //  start name
  .name {
    .flexStyle(top, center);
    img {
      .imgStyle(211px, 36px);
      margin-right: 35px;
    }
    span {
      .fontStyle(30px, #fff);
    }
  }
  //  end name
  // start menu
  .menu {
    .fontStyle(14px, #A8E2E6);
    margin-top: 40px;
    margin-bottom: 25px;
    span {
      padding-right: 20px;
      padding: 0px 10px;
      border-right: 1px solid #A8E2E6;
    }
    span:first-child {
      padding-left: 0px;
    }
    span:last-child {
      border-right: none;
    }
  }
  //  end menu
  // start contact
  .contact {
    .flexStyle(top, center);
    margin-bottom: 25px;
    .contactItem {
      .flexStyle(top, center);
      margin-bottom: 10px;
      margin-right: 60px;
      img {
        .imgStyle(15px, 15px);
        margin-right: 5px;
      }
      span {
        .fontStyle(14px, #A8E2E6);
      }
    }
  }
  // end contact
  // start copyright
  .copyright {
    .fontStyle(14px, #A8E2E6);
    display: flex;
    align-items: center;
    &>div:last-child{
      margin-left: 10px;
      display:flex;
      align-items: center;
      gap:5px;
    }
  }
  // end copyright
}
.fixedBotton {
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue